import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { Radio, RadioGroup } from '@material-ui/core';
import {
  compose, filter, findLast, isEmpty, map, reject,
} from 'lodash/fp';
import queryString from 'query-string';

import { fetchNewclazzMembersRequest } from '../actions';
import { fetchNewclazzRequest } from '../../clazz/actions';

import { AppBar } from '../components';
import { imgUserEmpty } from '../../common/assets';
import { Spinner } from '../../common/components';
import { convertGradeString } from '../../common/services/convertGrade';
import { nl2br } from '../../common/utils';

import chatTranslateInstance from '../../common/services/chatTranslate';

const Button = styled.button`
  width: 50%;
  height: 48px;

  border-top: 1px solid #f0f0f0;
`;

const Img = styled.img`
  width: 40px;
  height: 40px;

  object-fit: cover;
  border-radius: 40px;
`;

const S = {
  Wrapper: styled.div`
    display: flex;
    width: 100%;
  `,
  AppBar: styled(AppBar)`
    position: fixed;
    width: 100%;

    background-color: #fff;
    z-index: 10;
  `,
  Headings: styled.div`
    position: fixed;
    top: 60px;
    width: 100%;
    height: 24px;
    padding: 4px 5%;

    background-color: #f5f5f5;
    z-index: 10;

    color: #9b9b9b;
  `,
  Main: styled.main`
    position: relative;
    width: 100%;
    height: 100%;
    padding: 85px 0 45px 0;
    margin: 0 auto;

    background-color: #fff;
  `,
  Item: styled.div`
    width: 100%;
    height: 60px;
    display: flex;
    padding: 10px 20px;
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.07);
  `,
  ItemTitle: styled.div`
    width: 90%;
    height: 40px;
    padding: 10px;
  `,
  Empty: styled.div`
    margin: 100px 0;

    font-size: 16px;
    text-align: center;
  `,
  ActionBar: styled.div`
    position: fixed;
    width: 100%;
    bottom: 0;
    right: 0;
    background-color: #fff;
  `,
  Cancel: styled(Button)`
    color: #aaaaaa;
  `,
  Submit: styled(Button)`
    color: #30e3b8;
    border-left: 1px solid #f0f0f0;
  `,
  RadioGroup: styled(RadioGroup)`
    padding-bottom: 48px;
  `,
};

const mapStateToProps = (state) => ({
  clazz: state.clazz,
  members: state.members,
  users: state.users,
});

const mapDispatchToProps = {
  fetchNewclazz: fetchNewclazzRequest,
  fetchNewclazzMembers: fetchNewclazzMembersRequest,
};

class NewclassesMembers extends Component {
  state = {
    cid: '',
    member: {},
  };

  componentDidMount() {
    const {
      fetchNewclazz, fetchNewclazzMembers, match,
    } = this.props;

    fetchNewclazz({ cid: match.params.cid });
    fetchNewclazzMembers({ cid: match.params.cid });
    this.setState({
      cid: match.params.cid,
    });
  }

  getMembersList = () => {
    const {
      clazz,
      members,
      users,
    } = this.props;

    if (clazz.isLoadingNewclazz || users.isLoadingUserMe || !members.newclazzMembers) {
      return [];
    }

    const memberMe = findLast(['id', users.info.id])(members.newclazzMembers);

    if (!isEmpty(memberMe) && this.isMatchRole(memberMe, 'admin')) {
      return compose(
        filter(({ role }) => (role === 'member')),
        reject(['id', users.info.id]),
      )(members.newclazzMembers);
    }
    if (!isEmpty(memberMe) && (this.isMatchRole(memberMe, 'member'))) {
      return compose(
        filter(['role', 'admin']),
        reject(['id', users.info.id]),
      )(members.newclazzMembers);
    }

    return [];
  }

  isMatchRole = ({ role }, checkRole) => (
    role === checkRole
  )

  handleRadioClick = (member) => {
    this.setState({
      member,
    });
  }

  handleCancelClick = () => {
    const { history } = this.props;

    history.push({
      pathname: '/',
    });
  }

  handleSubmitClick = () => {
    const { history } = this.props;
    const {
      member,
      cid,
    } = this.state;

    if (isEmpty(member)) {
      return;
    }

    const params = { mid: member.id };
    history.push({
      pathname: `/newclasses/${cid}/chats`,
      search: queryString.stringify(params),
    });
  }

  render() {
    const {
      clazz,
      members,
      users,
      location,
    } = this.props;
    const { member } = this.state;
    const { lng } = queryString.parse(location.search);
    const i18nInstance = chatTranslateInstance.getChatTranslate().geti18Instance();

    if (lng) chatTranslateInstance.setLanguage(lng);
    if (clazz.isLoadingNewclazz || members.isLoadingNewclazzMembers || users.isLoadingUserMe) return (<Spinner />);

    return (
      <S.Wrapper>
        <S.AppBar />
        <S.Headings>
          {clazz.newclazz.schoolName}
          {convertGradeString(clazz.newclazz.grade, true)}
          {clazz.newclazz.name}
        </S.Headings>
        <S.Main>
          <S.RadioGroup>
            {
              isEmpty(this.getMembersList())
                ? <S.Empty>{ nl2br(i18nInstance.t('MESSAGE_NO_MEMBER_LIST')) }</S.Empty>
                : compose(
                  map((memberItem) => (
                    <S.Item key={memberItem.id}>
                      <Img
                        src={memberItem.profileImageUrl ? memberItem.profileImageUrl : imgUserEmpty}
                        onError={(event) => { event.target.onerror = null; event.target.src = imgUserEmpty; }}
                      />
                      <S.ItemTitle>{memberItem.name}</S.ItemTitle>
                      <Radio
                        value={memberItem.id}
                        onClick={() => this.handleRadioClick(memberItem)}
                      />
                    </S.Item>
                  )),
                )(this.getMembersList())
            }
          </S.RadioGroup>
        </S.Main>
        {
          isEmpty(this.getMembersList())
            ? <></>
            : (
              <S.ActionBar>
                <S.Cancel
                  onClick={this.handleCancelClick}
                >
                  { i18nInstance.t('Cancel') }
                </S.Cancel>
                <S.Submit
                  onClick={this.handleSubmitClick}
                  disabled={isEmpty(member)}
                >
                  { i18nInstance.t('MESSAGE_START_CHAT') }
                </S.Submit>
              </S.ActionBar>
            )
        }
      </S.Wrapper>
    );
  }
}

NewclassesMembers.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      sid: PropTypes.string,
      cid: PropTypes.string,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  fetchNewclazz: PropTypes.func.isRequired,
  fetchNewclazzMembers: PropTypes.func.isRequired,
  clazz: PropTypes.shape({
    isLoadingNewclazz: PropTypes.bool,
    newclazz: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      profileImageUrl: PropTypes.string.isRequired,
      schoolName: PropTypes.string,
      grade: PropTypes.string,
    }),
  }).isRequired,
  members: PropTypes.shape({
    isLoadingNewclazzMembers: PropTypes.bool,
    newclazzMembers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    ),
  }).isRequired,
  users: PropTypes.shape({
    isLoadingUserMe: PropTypes.bool,
    isLoadingSetRegisterUsers: PropTypes.bool,
    info: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      profile_image: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewclassesMembers);
